import React, { useEffect, useState } from 'react'
import { useContext, useLanguage } from '~/hooks'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import * as st from '~/assets/styl/Hero.module.styl'

export default function Hero() {
  const { openHamburger } = useContext()

  const mobile = Boolean(useBreakpoint().sm)
  const [height, setHeight] = useState(0)
  useEffect(() => {
    setHeight(mobile ? window.innerHeight : 0)
  }, [mobile])
  const { t } = useLanguage()
  return (
    <header
      id="Home"
      className={st.core}
      style={height ? { paddingTop: height } : null}
    >
      <h1 className={st.title}>{t('Hero.title')}</h1>
      <div className={st.fixed}>
        <a
          href="/dvert-residence/"
          className={
            process.env.GATSBY_LANGUAGE === 'pt' ? st.active : undefined
          }
        >
          PT
        </a>
        <a
          href="/en/dvert-residence/"
          className={
            process.env.GATSBY_LANGUAGE === 'en' ? st.active : undefined
          }
        >
          EN
        </a>
        <a
          href="/es/dvert-residence/"
          className={
            process.env.GATSBY_LANGUAGE === 'es' ? st.active : undefined
          }
        >
          ES
        </a>
        <button
          className={st.hamburger}
          onClick={() => openHamburger()}
        ></button>
      </div>
    </header>
  )
}
